
import ModalEducateUsers from '@marketplace/components/modals/modal-educate-users.vue'

export default {
    name: 'ModalPaymentMethods',

    components: {
        ModalEducateUsers,
    },

    data() {
        return {
            steps: [],
        }
    },

    created() {
        this.steps = [
            {
                title: `${this.$t('labels.preferred-payment-method-title')}`,
                description: this.$t(
                    'labels.preferred-payment-method-description'
                ),
                backgroundColor: '#DDB254',
                imageUrl:
                    require('~/assets/images/how-oc-works/payment-method-image-01.svg'),
            },
        ]
    },
}
